import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDialogs } from "../hooks/use-dialogs";
import useTemaModel from "../model/tema";
import { useUserStore } from "../store/user-store";
import { Tema } from "../types/general";
import { isUser } from "../utils/access-control";
import usePerguntaStore from "../zustand/use-pergunta-store";
import useTemaStore from "../zustand/use-tema-store";

export const ViewModelTema = () => {

  const navigate = useNavigate();
  const { user } = useUserStore();

  const { resetState } = usePerguntaStore((state) => ({ resetState: state.resetState }));

  const {
    temas,
    selectedTema,
    setSelectedTema,
  } = useTemaStore();

  const {
    fetchTemas,
    fetchMyTemas,
    createTema,
    updateTemaById,
    deleteTemaById
  } = useTemaModel();

  const {
    close,
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning
  } = useDialogs();

  // Select tema for editing
  const selectTema = (tema: Tema) => {
    setSelectedTema(tema);
  };

  useEffect(() => {
    // USER users should only see their assigned temas via /api/temas/my
    // ADMIN users see all temas via /api/temas
    if (isUser(user)) {
      fetchMyTemas();
    } else {
      fetchTemas();
    }
  }, [user])

  // Clear selection
  const clearSelection = () => {
    setSelectedTema(undefined as any);
  };

  // Navigate to perguntas page for a tema
  const goToPerguntas = (temaId: number) => {
    resetState();
    setSelectedTema(temas.data.find((item) => item.id === temaId) as Tema)
    navigate(`/perguntas?tema=${temaId}`);
  };

  const handleDeleteTema = (id: number) => {
    close();
    deleteTemaById(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Tema removido com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao remover o tema!',
        })
      }
    })
  }

  const handleActionTema = (tema: Tema, action: 'add' | 'update') => {
    if (action === 'add') {
      createTema(tema as any, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Tema criado com sucesso!'
          });
        },
        error: (error) => {
          console.log(error)
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao criar o tema!',
          })
        }
      });
    } else {
      updateTemaById(tema, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Tema actualizado com sucesso!'
          });
        },
        error: () => {
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao actualizar o tema!',
          })
        }
      });
    }
  }

  return {
    user,
    temas,
    selectedTema,
    showError,
    showSuccess,
    showWarning,
    fetchTemas,
    handleActionTema,
    handleDeleteTema,
    selectTema,
    clearSelection,
    goToPerguntas,
    navigate,
    dialog,
    showConfirmation
  };
};
